import React, {useMemo} from "react";
import {Table} from "rsuite";

// const style = {
//     display: 'flex',
//     justifyContent: 'left',
//     backgroundColor: 'var(--rs-bg-card)',
//     border: '1px solid var(--rs-border-secondary)',
// };

const TreeGrid = (props) => {
    const {loading, data, columns, rowKey} = props;
    return useMemo(() => {
        return (
            <>
                <Table
                    isTree
                    rowKey={rowKey}
                    loading={loading}
                    height={300}
                    hover
                    showHeader
                    autoHeight
                    data={data}
                    bordered
                    cellBordered
                    headerHeight={40}
                    rowHeight={46}
                >
                    {columns.map(column => {
                        const {key, label, flexGrow, rowData, ...rest} = column;
                        return (
                            <Table.Column {...rest} key={key} flexGrow={flexGrow ? flexGrow : 1}>
                                <Table.HeaderCell>{label}</Table.HeaderCell>
                                <Table.Cell dataKey={key} />
                            </Table.Column>
                        );
                    })}
                </Table>
                </>
        );
        }, [columns, loading, data, rowKey]);
}

export default TreeGrid;